import api from '@/api';

const { $core } = api;

export const { $rules, $chapter, $subchapter} = $core
